import axios from 'axios';

export const API_BASE_URL =
  (import.meta.env.VITE_API_URL || '').replace(/\/$/, '') ||
  (import.meta.env.DEV ? 'http://localhost:3000' : 'https://api.turnivo.pl');
export const DEMO_MODE = import.meta.env.VITE_DEMO_MODE === 'true';

/** URL panelu organizatora (logowanie, dashboard). Landing przekierowuje tu "Zaloguj się" / "Otwórz panel". */
export const PANEL_URL =
  (import.meta.env.VITE_PANEL_URL || '').replace(/\/$/, '') ||
  (import.meta.env.DEV ? 'http://localhost:5173' : 'https://panel.turnivo.pl');

export const checkApiHealth = async (): Promise<boolean> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/health`, { timeout: 5000 });
    return response.status === 200;
  } catch {
    return false;
  }
};
